import React from 'react';
import { Link } from 'react-router-dom';

// Styles
import styles from "./../StaffManagment.module.css";

// Images
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";
import clockIcon from "../../../../assets/img/DashboardICons/ClockIcon.svg"

const StaffSupportCardBoxNotif = (props) => {

    return (
        <>
            <div dir="rtl" className={`text-right mx-4 px-2 pt-2 pb-3 mt-2 mb-3`}>
                <div className={`d-flex align-items-start justify-content-between flex-wrap`}>
                    {
                        props.staffSupportMessageData?.map(data => (
                            <div
                                key={data?.id}
                                style={{ width: props.startNewMessage ? "48.5%" : "100%" }}
                                className={`position-relative d-flex align-items-center justify-content-between flex-wrap mt-3 mb-2 p-3 ${styles.total_staff_support_card_box}`}>


                                <div className={`d-flex align-items-center justify-content-start`}>
                                    <img className={`${styles.image_staff_card_box}`} src={`https://backdev.azrmelk.com/images/users/avatar/${data?.receiverUserDto?.avatarName}`} alt="user-profile" style={{ borderRadius: "50%" }} />
                                    <span className={`pe-4 mb-0 ${styles.title_staff_card_box}`}> {data?.receiverUserDto?.fullName} </span>
                                    <span style={{ color: "#8D8D8D" }} className={`pe-2 mb-0 ${styles.subTitle_staff_card_box}`}> {data?.areaRole} </span>
                                </div>

                                <div className="d-flex align-items-center justify-conten-start">
                                    <img className="ms-3" src={clockIcon} alt="icon" />
                                    <div className={styles.date_info_text}>
                                        {data.createDate.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                    </div>
                                </div>

                                <Link to={{
                                    pathname: `/staff-managment-support-card-detail/${data.id}`,
                                    state: data
                                }} className={`ms-2 ${styles.link_icon_text}`}>
                                    مشاهده
                                    <img className='me-2' src={arrowBlue} alt="arrow-blue-icon" width="15" />
                                </Link>

                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    )
}

export default StaffSupportCardBoxNotif;
